import React from "react";

export default function TextField({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  disabled = false,
  autoComplete,
  invalid = false,
  invalidText,
}) {
  const inputId = name || `text-${label?.toLowerCase().replace(/\s+/g, "-")}`;
  const feedbackId = invalid ? `${inputId}-feedback` : undefined;

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label" htmlFor={inputId}>
          {label}
        </label>
      )}
      <input
        id={inputId}
        name={name}
        type="text"
        className={`form-control ${invalid ? "is-invalid" : ""}`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        aria-describedby={feedbackId}
      />
      {invalid && invalidText && (
        <div id={feedbackId} className="invalid-feedback">
          {invalidText}
        </div>
      )}
    </div>
  );
}
